// extracted by mini-css-extract-plugin
export var actionButton = "_9x-0";
export var attachmentLine = "_9x-1";
export var fileInput = "_9x-2";
export var fileUploadWrapper = "_9x-4";
export var footer = "_9x-3";
export var modalContent = "_9x-5";
export var paperclip = "_9x-6";
export var quillEditor = "_9x-7";